import type { ComposerTranslation } from 'vue-i18n'
import { TenderDisplayStatusEnum } from '@apiTypes'

const TENDER_EDITABLE_DISPLAY_STATUSES = new Set<TenderDisplayStatusEnum>([
  TenderDisplayStatusEnum.DRAFT,
  TenderDisplayStatusEnum.OPEN,
  TenderDisplayStatusEnum.EVALUATING,
])

/**
 * Display statuses where tender is considered "editable" (OPEN or EVALUATING).
 * Used for contract cancellation logic and other evaluation-phase actions.
 */
export const TENDER_EDITABLE_STATUSES = [
  TenderDisplayStatusEnum.OPEN,
  TenderDisplayStatusEnum.EVALUATING,
]

/** Display statuses where the tender edit UI and edit route are allowed. */
export function isTenderEditableDisplayStatus(
  status: TenderDisplayStatusEnum | null | undefined,
): boolean {
  return status != null && TENDER_EDITABLE_DISPLAY_STATUSES.has(status)
}

/**
 * Display statuses where the tender actions (kebab) menu is shown.
 * Uses the same allowlist as edit routing, plus canceled (delete-only).
 * Unknown/future statuses stay hidden until explicitly allowed here.
 */
export function isTenderActionsMenuDisplayAllowed(
  status: TenderDisplayStatusEnum | null | undefined,
): boolean {
  return (
    isTenderEditableDisplayStatus(status)
    || status === TenderDisplayStatusEnum.CANCELED
  )
}

export function tenderDisplayStatusLabel(
  status: TenderDisplayStatusEnum,
  t: ComposerTranslation,
): string {
  switch (status) {
    case TenderDisplayStatusEnum.DRAFT:
      return t('Draft')
    case TenderDisplayStatusEnum.OPEN:
      return t('Open')
    case TenderDisplayStatusEnum.EVALUATING:
      return t('Evaluating')
    case TenderDisplayStatusEnum.FINISHED:
      return t('Finished')
    case TenderDisplayStatusEnum.CANCELED:
      return t('Canceled')
    default:
      return t('Unknown status')
  }
}
